import { RouteLocation } from "vue-router";
import { useBldgStore } from "../store/bldgStore";
import { useUserStore } from "./../store/userStore";

export default async (to: RouteLocation, from: RouteLocation) => {
  // Try to load building data if this is a new building
  let siteCode = to.params.bldgCode?.toString() ?? to.params.sitecode?.toString();
  if (siteCode) {
    siteCode = (siteCode as string).trim().toLowerCase();
    // console.log(`Router found a siteCode param as "${bldgCode}"`);
    const bldgStore = useBldgStore();
    await bldgStore.tryGetBuildingData(siteCode);

    const userStore = useUserStore();

    // redirect to login screen if not logged in
    if (!userStore.isUserLoading && !userStore.isLoggedIn) {
      console.log("authGuard> User not found. Redirecting.");
      return `/${siteCode}/login?returnUrl=${to.fullPath}`;
    }

    var user = userStore.user;
    if (user?.portalId === bldgStore.property?.portalId && !user?.isComplete) {
      return `/${siteCode}/externalregister?returnUrl=${to.fullPath}`;
    }

    console.log(
      "tenant email is required",
      bldgStore.property?.tenants?.filter((t) => t.tenantId == user?.tenantId)[0]
        ?.isEmailVerificationRequired
    );
    console.log("user email is verified", user?.isEmailVerified);
    if (
      !userStore.isUserLoading &&
      userStore.isLoggedIn &&
      bldgStore.property?.tenants?.filter((t) => t.tenantId == user?.tenantId)[0]
        ?.isEmailVerificationRequired &&
      !user?.isEmailVerified
    ) {
      return `/${siteCode}/unconfirmedemail?returnUrl=${to.fullPath}`;
    }
  } else {
    console.log(" Didn't find a siteCode");
  }
};
